
export class SocialSiteType {

        public static readonly className:string = "com.tanzeel.common.vo.SocialSiteTypeVO";

        constructor(){}

        code: string;
        description: string;
        clientId: string;
        secretCode: string;
        socialUrl: string;

}
